import { App } from './app/App.js';

const mount = document.getElementById('app');
if (!mount) throw new Error('#app missing');

/** Kill browser chrome around right/middle click (context menu, new tab, reload). */
function blockBrowserMouseChrome(e: Event): void {
  e.preventDefault();
}

document.addEventListener('contextmenu', blockBrowserMouseChrome, true);
document.addEventListener(
  'auxclick',
  (e) => {
    // Middle-click (1) opens tabs; right (2) can still fire auxclick in some browsers.
    if (e.button === 1 || e.button === 2) e.preventDefault();
  },
  true,
);
document.addEventListener(
  'mousedown',
  (e) => {
    if (e.button === 1 || e.button === 2) e.preventDefault();
  },
  true,
);
document.addEventListener(
  'mouseup',
  (e) => {
    if (e.button === 1 || e.button === 2) e.preventDefault();
  },
  true,
);

document.addEventListener(
  'click',
  () => {
    /* AudioManager starts on first gesture via GameController */
  },
  { once: true },
);

new App(mount);
